import axios from 'axios';

// Small authenticated client for the estimate endpoints. GETs and JSON POSTs
// include the signed-in user's email as `username`, like the rest of the app;
// FormData callers append it themselves.
export const estimateApi = user => {
  const call = async (method, path, { data, params } = {}) => {
    const token = await user.getIdToken();
    const response = await axios({
      method,
      url: `${process.env.REACT_APP_BACKEND_URL}${path}`,
      data,
      params,
      headers: { authorization: token },
    });
    return response.data;
  };

  return {
    username: user.email,
    get: (path, params) =>
      call('get', path, { params: { username: user.email, ...params } }),
    post: (path, data) =>
      call('post', path, {
        data:
          data instanceof FormData ? data : { username: user.email, ...data },
      }),
  };
};

export const errorMessage = (error, fallback = 'Please try again.') =>
  error?.response?.data?.message || fallback;

export const formatFileSize = bytes =>
  !bytes
    ? ''
    : bytes >= 1024 * 1024
    ? `${(bytes / 1024 / 1024).toFixed(1)} MB`
    : `${Math.max(1, Math.round(bytes / 1024))} KB`;

// Short id that matches the backend's custom option id format.
export const newOptionId = () =>
  `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
